var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_558_36228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33337 2.66602H2.66671C2.31309 2.66602 1.97395 2.80649 1.7239 3.05654C1.47385 3.30659 1.33337 3.64573 1.33337 3.99935V13.3327C1.33337 13.6863 1.47385 14.0254 1.7239 14.2755C1.97395 14.5255 2.31309 14.666 2.66671 14.666H12C12.3537 14.666 12.6928 14.5255 12.9428 14.2755C13.1929 14.0254 13.3334 13.6863 13.3334 13.3327V8.66602",
    stroke: "#714FFF",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 1.66617C12.5986 1.40095 12.9583 1.25195 13.3334 1.25195C13.7084 1.25195 14.0682 1.40095 14.3334 1.66617C14.5986 1.93138 14.7476 2.29109 14.7476 2.66617C14.7476 3.04124 14.5986 3.40095 14.3334 3.66617L8.00004 9.9995L5.33337 10.6662L6.00004 7.9995L12.3334 1.66617Z",
    stroke: "#714FFF",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_558_36228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2fa946a7a364818e5fdd2428014a90de.svg";
export { ForwardRef as ReactComponent };